module.exports = __webpack_public_path__ + "img/Production.796e25f3.gif";